export const VARIANT_LIST = ['Master data'];
